// Types
import {
  ErrorStateBuilderHandlersType,
  ErrorStateMethodsHandlersType,
  ErrorStateSuccessBuilderHandlersType,
} from './types/error-state.handlers.type';
import { GetStateSuccessType } from 'types/get-state-success.type';
// Utils
import { onboardingHasBeenDeclinedByRisk } from 'utils/state.handlers.utils';

const manageSuccessGetStateFromErrorEventHandler = ({
  state,
  resetBoundary,
  setCurrentState,
  handleLogCallbackUrlCallEvent,
}: ErrorStateSuccessBuilderHandlersType): void => {
  if (onboardingHasBeenDeclinedByRisk(state)) {
    handleLogCallbackUrlCallEvent();
  } else {
    setCurrentState(state);
    resetBoundary();
  }
};

const manageFailGetStateFromErrorEventHandler = ({
  handleLogCallbackUrlCallEvent,
}: Pick<ErrorStateBuilderHandlersType, 'handleLogCallbackUrlCallEvent'>): void => {
  handleLogCallbackUrlCallEvent();
};

const ErrorStateHandlers = ({
  setCurrentState,
  resetBoundary,
  ...props
}: ErrorStateBuilderHandlersType): ErrorStateMethodsHandlersType => ({
  handleManageSuccessGetStateFromErrorEvent: (response: GetStateSuccessType) =>
    manageSuccessGetStateFromErrorEventHandler({
      ...response,
      ...props,
      resetBoundary,
      setCurrentState,
    }),
  handleManageFailGetStateFromErrorEvent: () => manageFailGetStateFromErrorEventHandler(props),
});

export { ErrorStateHandlers };
